// 此文件存在于 Free, Analytics项目中如果修改需要确认是否进行同步修改
import { forEach, get } from 'lodash';
import { getCurrentLanguage } from 'library-@/utils/getCurrentLanguage';

function getStructureLink(descList) {
    if (!descList || descList.length === 0) {
        return;
    }
    let descLinkArr = [];
    forEach(descList, item => {
        let title = _getTranslateTitle(item);
        if (title) {
            descLinkArr.push({
                title,
                category_id: item
            });
        }
    });
    return descLinkArr;
}
const fieldsKeyMap = [
    {
        EN: 'Technical Field',
        CN: '技术领域',
        JP: '技術分野',
        DE: 'Technisches Feld',
        TW: '技術領域'
    },
    {
        EN: 'Background Art',
        CN: '背景技术',
        JP: '背景技術',
        DE: 'Hintergrund der Technik',
        TW: '背景技術'
    },
    {
        EN: 'Summary of Invention',
        CN: '发明内容',
        JP: '発明の概要',
        DE: 'Zusammenfassung der Erfindung',
        TW: '發明內容'
    },
    {
        EN: 'Brief Description of Drawings',
        CN: '附图说明',
        JP: '図面',
        DE: 'Kurze Beschreibung der Zeichnungen',
        TW: '附圖說明'
    },
    {
        EN: 'Description of Embodiments',
        CN: '具体实施方式',
        JP: '詳細な実装',
        DE: 'Beschreibung der Ausführungsformen',
        TW: '具體實施方式'
    }
];
function _getTranslateTitle(id) {
    let lang = getCurrentLanguage();
    lang = lang.toLocaleUpperCase();
    const title = get(fieldsKeyMap[id - 1], lang, '');
    return title;
}

export { getStructureLink };
